/** Pulse residency option type IDs synced on pulse-location.residencyOption */
export const RESIDENCY_TYPE_DAY = 356000
export const RESIDENCY_TYPE_OVERNIGHT = 356001
export const RESIDENCY_TYPE_DAY_AND_OVERNIGHT = 356002

export type ResidencyOptionLike = {
  typeId?: number | string | null
  name?: string | null
} | null | undefined

export function residencyTypeId(residencyOption: ResidencyOptionLike): number | null {
  const raw = residencyOption?.typeId
  if (raw === null || raw === undefined || raw === '') {
    return null
  }
  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : null
}

function residencyDisplayFlags(typeId: number | null): { showDay: boolean; showOvernight: boolean } {
  switch (typeId) {
    case RESIDENCY_TYPE_DAY:
      return { showDay: true, showOvernight: false }
    case RESIDENCY_TYPE_OVERNIGHT:
      return { showDay: false, showOvernight: true }
    case RESIDENCY_TYPE_DAY_AND_OVERNIGHT:
      return { showDay: true, showOvernight: true }
    default:
      return { showDay: false, showOvernight: false }
  }
}

export function showsDayResidency(residencyOption: ResidencyOptionLike): boolean {
  return residencyDisplayFlags(residencyTypeId(residencyOption)).showDay
}

export function showsOvernightResidency(residencyOption: ResidencyOptionLike): boolean {
  return residencyDisplayFlags(residencyTypeId(residencyOption)).showOvernight
}
